import { useState } from "react";

const faqItems = [
  {
    question: "什么是Po文？Po文是什么意思？",
    answer: "Po文源自英文「Post」，指的是在社交媒体、论坛、部落格等平台上发布的文章或贴文。在台湾和香港的网络用语中，「Po文」已经成为日常用语，泛指在网络上发表内容的行为。一篇好的po文需要兼顾标题吸引力、内容质量和排版美观度。",
  },
  {
    question: "Po文怎么写才能获得更多互动？",
    answer: "提高po文互动率的关键在于三个方面：一是标题要有吸引力，善用数字、问题、对比等技巧；二是内容要有价值，提供实用信息或情感共鸣；三是排版要清晰易读，善用分段、符号和留白。此外，在po文结尾引导互动（如提问、投票）也能有效提升评论率。",
  },
  {
    question: "Po文最佳发布时间是什么时候？",
    answer: "不同平台的最佳时间有所不同：Facebook建议工作日9:00-11:00和19:00-21:00；Instagram推荐12:00-13:00和20:00-22:00；Threads则在8:00-10:00和17:00-19:00表现最佳。但最精准的方式是分析你自己粉丝的活跃时间，建立个性化的发布排程。",
  },
  {
    question: "新手学Po文应该从哪里开始？",
    answer: "建议从「模仿 + 练习」开始。先关注你所在领域的优秀创作者，分析他们po文的标题、结构和排版方式，然后尝试用自己的语言和角度来创作。同时，从短篇内容（300-500字）开始练习，逐步提升内容深度和长度。我们的「Po文范例」分类中有大量可参考的案例。",
  },
  {
    question: "Po文排版真的那么重要吗？",
    answer: "非常重要！研究显示，排版良好的内容完读率比排版本混乱的内容高出3-5倍。在移动端阅读场景下，清晰的排版（短段落、适当留白、关键词标记）直接决定了读者是否会读完你的内容。建议每个段落不超过4行，善用Emoji和符号引导阅读节奏。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900"
            style={{ fontFamily: "var(--font-heading)" }}>
            常见问题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm">
            关于Po文创作，你可能会想知道的事
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-200"
              >
                <button
                  className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 text-lg flex-shrink-0 transition-transform duration-200 ${
                      isOpen ? "rotate-180" : ""
                    }`}
                  ></i>
                </button>

                <div
                  className={`px-5 overflow-hidden transition-all duration-300 ${
                    isOpen ? "pb-4 max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}